/**
 * URL карточки диагностики: `/{town}/{group}/{translit}/`.
 *
 * Пустой group/translit — ссылки нет, строка остаётся текстом.
 */
export default function getDiagnosticServiceHref(
  townTranslit: string,
  group?: string,
  translit?: string,
): string {
  if (!townTranslit || !group || !translit) {
    return ''
  }

  return `/${townTranslit}/${group}/${translit}/`
}
